import React from 'react';
import { Navigate } from 'react-router-dom';
import Error404 from 'src/views/Error404';
import Login from 'src/views/Login';
import Profil from 'src/views/Profile';
import UnauthorizedView from 'src/views/Unauthorized';
import DashboardLayout from './layouts/Dashboard';
import ErrorLayout from './layouts/Error';
import ChatView from './views/Chat';
import OpenServiceView from './views/OpenService';
import ConfirmView from './views/Confirm';
import CloseConfirm from './views/CloseConfirm';
import CloseServiceView from './views/CloseService';
import OpenConfirmReport from './views/Report/OpenConfirmReport';
import CloseConfirmReport from './views/Report/CloseConfirmReport';
import EmployeeInformationReport from './views/Report/EmployeeInformationReport';
import EmployeeMultipleUsedIdReport from './views/Report/EmployeeMultipleUsedIdReport';
import JointService from './views/JointService';
import EmployeeIdentifyReport from './views/Report/EmployeeIdentifyReport';
import EmployeePhoneList from './views/Report/EmployeePhoneList';
import EmployeeTypeReport from './views/Report/EmployeeTypeReport';
import OpenReject from './views/OpenReject';
import CloseReject from './views/CloseReject';
import EmployeeView from './views/Employee';
import RoleView from './views/Role';
import EmployeeMainView from './views/EmployeeMain';
import SmsManagementDynamicView from './views/SmsManagementDynamic';
import RoleManagementView from './views/RoleManagement';
import HelpView from './views/Help';
import HVACView from './views/HVAC';
import HVACReportView from './views/HVACReport';
import HVACOffersView from './views/HVACOffers';
import MaterialEquivalentView from './views/MaterialEquivalentReport';
import SestekAiView from './views/SestekAi';
import SestekAiReportView from './views/SestekAiReport';
import DealerShippingPricesView from './views/DealerShippingPrices';
import TeknisyenKocuGorusmeView from './views/TeknisyenKocuGorusme';
import BannerView from './views/Banner';
import YsHelp from './views/Help/yshelp';
import BeratManagement from './views/BeratManagement';
import ServiceManagement from './views/ServiceManagement';
import EkipmanAdminYonetimi from './views/EkipmanAdminYonetimi';
import EkipmanYonetimi from './views/EkipmanYonetimi';
import ServicePhotos from './views/ServicePhotos';
import ServiceInformations from './views/ServiceInformations';
import ServiceOperatorLog from './views/ServiceOperatorLog';
import ServiceVehicles from './views/ServiceVehicles';
import IndividualProductInquiryView from './views/IndividualProductInquiry';
import ReceiptDetailView from './views/IndividualProductInquiry/receiptDetail';
import ReceiptStatusHistoryView from './views/IndividualProductInquiry/ReceiptStatusHistory';
import ReceiptCustomerView from './views/IndividualProductInquiry/ReceiptCustomer';
import ReceiptCustomerDetailView from './views/IndividualProductInquiry/ReceiptCustomerDetail';
import IndividualInquiryReceiptsView from './views/IndividualProductInquiry/IndividualInquiryReceipts';
import WarrantyTypeDetailView from './views/SarisDynamicWarranty/WarrantyTypeDetail';
import ReportMonitoringView from './views/ReportMonitoring';
import BpoMutabakatView from './views/BpoMutabakat';
import SarisDynamicProductView from './views/SarisDynamicProduct';
import SarisDynamicWarrantyView from './views/SarisDynamicWarranty';
import SarisDynamicUnitView from './views/SarisDynamicUnit';
import SarisDynamicUnitDetailView from './views/SarisDynamicUnit/SarisDynamicUnitDetail';
import MultipleReceiptInquiryView from './views/MultipleReceiptInquiry';
import AssemblyBudgetDynamicTabView from './views/AssemblyBudget';
import RuleView from './views/Rule';
import UnregisteredReturnsView from './views/UnregisteredReturns';
import AsrReportsView from './views/ASRReports';
import ReportRequestScreen from './views/ReportRequestScreen/ReportRequestScreen';
import ReportRequestScreen_2 from './views/ReportRequestScreen/ReportRequestScreen';
import SarisDynamicServiceLaborMaterialView from './views/SarisDynamicServiceLaborMaterial';
import DynamicServiceDetailView from './views/SarisDynamicServiceLaborMaterial/DynamicServiceDetail';
import SarisDynamicOtherlView from './views/SarisDynamicOther';
import OtherDynamicDetaillView from './views/SarisDynamicOther/OtherDynamicDetail';
import SarisFcmCalculateView from './views/SarisFcmCalculate';
import ServiceVisit from './views/ServiceDealerVisit';
import CelebrationManagement from './views/CelebrationManagement';
import ReceiptQuery from './views/ReceiptQuery';
import LocationManagement from './views/LocationManagement';
import SearchWorkOrderView from './views/THWorkOrder/SearchWorkOrder';
import FileManagementView from './views/FileManagement';
import ServiceTrackingReport from './views/ServiceTracking';
import YSBeratManagement from './views/BeratManagement/YSBerat';
import ServiceVisitReport from './views/ServiceVisitReport';
import LaborFormView from './views/LaborForm';
import TeknisyenKocuChatView from './views/FileManagement/TeknisyenKocuChat';
import CreateBulletin from './views/Bulletin/CreateBulletin';
import BulletinList from './views/Bulletin/BulletinList';
import DraftList from './views/Bulletin/DraftList';
import PanelRepairDeliveriesView from './views/LogisticsTracking/PanelRepairDeliveries';
import PanelServicePickupsView from './views/LogisticsTracking/PanelServicePickups';
import TseHybSurecleriView from './views/TseHybSurecleri';
import AronRotamView from './views/AronRotam';

// Lazy: layouts/Auth/index.js imports this file back (for useRoutes(routes)),
// so a static import here would be a circular require that webpack 5
// evaluates as "Cannot access 'AuthLayout' before initialization".
const AuthLayout = React.lazy(() => import('./layouts/Auth'));

export default [
  {
    path: '/',
    element: <Navigate to="/" replace />
  },
  {
    path: '/auth',
    element: <AuthLayout />,
    children: [
      {
        path: 'login',
        element: <Login />
      },
      {
        path: '*',
        element: <Navigate to="/errors/error-404" replace />
      }
    ]
  },
  {
    path: '/Unauthorized',
    element: <ErrorLayout />,
    children: [
      {
        index: true,
        element: <UnauthorizedView />
      },
      {
        path: '*',
        element: <Navigate to="/Unauthorized" replace />
      }
    ]
  },
  {
    path: '/errors',
    element: <ErrorLayout />,
    children: [
      {
        path: 'error-404',
        element: <Error404 />
      },
      {
        path: '*',
        element: <Navigate to="/errors/error-404" replace />
      }
    ]
  },
  {
    element: <DashboardLayout />,
    children: [
      {
        path: 'OpenService/:id',
        element: <Profil />
      },
      {
        path: 'OpenService',
        element: <OpenServiceView />
      },
      {
        path: 'Confirm',
        element: <ConfirmView />
      },
      {
        path: 'CloseService',
        element: <CloseServiceView />
      },
      {
        path: 'Help',
        element: <HelpView />
      },
      {
        path: 'YsHelp',
        element: <YsHelp />
      },
      {
        path: 'Chat',
        element: <ChatView />
      },
      {
        path: 'profile/:id',
        element: <Profil />
      },
      {
        path: 'profile/:id/:tab',
        element: <Profil />
      },
      {
        path: 'SmsManagementDynamic',
        element: <SmsManagementDynamicView />
      },
      {
        path: 'MaterialEquivalentReport',
        element: <MaterialEquivalentView />
      },
      {
        path: 'SestekAi',
        element: <SestekAiView />
      },
      {
        path: 'TeknisyenKocuGorusme',
        element: <TeknisyenKocuGorusmeView />
      },
      {
        path: 'SestekAiReport',
        element: <SestekAiReportView />
      },
      {
        path: 'Banner',
        element: <BannerView />
      },
      {
        path: 'EkipmanAdminYonetimi',
        element: <EkipmanAdminYonetimi />
      },
      {
        path: 'EkipmanYonetimi',
        element: <EkipmanYonetimi />
      },
      {
        path: 'Rule',
        element: <RuleView />
      },
      {
        path: 'UnregisteredReturns',
        element: <UnregisteredReturnsView />
      },
      {
        path: 'DealerShippingPrices',
        element: <DealerShippingPricesView />
      },
      {
        path: 'Employee',
        element: <EmployeeView />
      },
      {
        path: 'HVAC',
        element: <HVACView />
      },
      {
        path: 'HVACReport',
        element: <HVACReportView />
      },
      {
        path: 'HVACOffers',
        element: <HVACOffersView />
      },
      {
        path: 'Role',
        element: <RoleView />
      },
      {
        path: 'EmployeeInformation',
        element: <EmployeeInformationReport />
      },
      {
        path: 'EmployeeMultipleUsedId',
        element: <EmployeeMultipleUsedIdReport />
      },
      {
        path: 'EmployeeIdentifyReport',
        element: <EmployeeIdentifyReport />
      },
      {
        path: 'EmployeePhoneList',
        element: <EmployeePhoneList />
      },
      {
        path: 'EmployeeTypeReport',
        element: <EmployeeTypeReport />
      },
      {
        path: 'EmployeeMain/:id',
        element: <EmployeeMainView />
      },
      {
        path: 'close/confirm',
        element: <CloseConfirm />
      },
      {
        path: 'report/openConfirm',
        element: <OpenConfirmReport />
      },
      {
        path: 'report/closeConfirm',
        element: <CloseConfirmReport />
      },
      {
        path: 'OpenReject',
        element: <OpenReject />
      },
      {
        path: 'CloseReject',
        element: <CloseReject />
      },
      {
        path: 'RoleManagement',
        element: <RoleManagementView />
      },
      {
        path: 'ServiceManagement',
        element: <ServiceManagement />
      },
      {
        path: 'JointService',
        element: <JointService />
      },
      {
        path: 'BeratManagement',
        element: <BeratManagement />
      },
      {
        path: 'ServicePhotos',
        element: <ServicePhotos />
      },
      {
        path: 'ServiceInformations',
        element: <ServiceInformations />
      },
      {
        path: 'ServiceOperatorLog',
        element: <ServiceOperatorLog />
      },
      {
        path: 'ServiceTracking',
        element: <ServiceTrackingReport />
      },
      {
        path: 'YSBeratManagement',
        element: <YSBeratManagement />
      },
      {
        path: 'ServiceVehicles',
        element: <ServiceVehicles />
      },
      {
        path: 'ServiceDealerVisit',
        element: <ServiceVisit />
      },
      {
        path: 'ServiceVisitReport',
        element: <ServiceVisitReport />
      },
      {
        path: 'SarisQueries/IndividualProductInquiry',
        element: <IndividualProductInquiryView />
      },
      {
        path: 'SarisQueries/ReceiptDetails/:ReceiptNumber',
        element: <ReceiptDetailView />
      },
      {
        path: 'IndividualInquiryReceipts/:UYear/:UPeriod/:ModelCode/:SerialNo',
        element: <IndividualInquiryReceiptsView />
      },
      {
        path: 'ReceiptStatusHistory/:ReceiptNumber',
        element: <ReceiptStatusHistoryView />
      },
      {
        path: 'ReceiptCustomer/:PhoneNumber',
        element: <ReceiptCustomerView />
      },
      {
        path: 'ReceiptCustomerDetail/:CustomerNo',
        element: <ReceiptCustomerDetailView />
      },
      {
        path: 'SarisQueries/ReportMonitoring',
        element: <ReportMonitoringView />
      },
      {
        path: 'SarisQueries/ReportRequestScreen',
        element: <ReportRequestScreen />
      },
      {
        path: 'SarisQueries/ReportRequestScreen/:No',
        element: <ReportRequestScreen_2 />
      },
      {
        path: 'SarisDesc/SarisDynamicProduct',
        element: <SarisDynamicProductView />
      },
      {
        path: 'SarisDesc/SarisDynamicWarranty',
        element: <SarisDynamicWarrantyView />
      },
      {
        path: 'SarisDesc/SarisDynamicUnit',
        element: <SarisDynamicUnitView />
      },
      {
        path: 'SarisDesc/SarisFcmCalculate',
        element: <SarisFcmCalculateView />
      },
      {
        path: 'SarisDynamicUnitDetail/:UnitCode/:UserUnitCode/:UnitDesc',
        element: <SarisDynamicUnitDetailView />
      },
      {
        path: 'SarisQueries/MultipleReceiptInquiry',
        element: <MultipleReceiptInquiryView />
      },
      {
        path: 'WarrantyTypeDetail/:WarrantyType/:WarrantyDesc',
        element: <WarrantyTypeDetailView />
      },
      {
        path: 'AsrReports/ArcelikServiceReports',
        element: <AsrReportsView />
      },
      {
        path: 'AssemblyBudget/LaborPriceEstimation',
        element: <AssemblyBudgetDynamicTabView />
      },
      {
        path: 'SarisDesc/SarisDynamicServiceLaborMaterial',
        element: <SarisDynamicServiceLaborMaterialView />
      },
      {
        path: 'SarisDesc/SarisDynamicServiceLaborMaterialDetail/:UserCode/:ElType/:ElCode/:UserElCode/:Description',
        element: <DynamicServiceDetailView />
      },
      {
        path: 'SarisDesc/SarisDynamicOther',
        element: <SarisDynamicOtherlView />
      },
      {
        path: 'SarisDesc/OtherDynamicDetaill/:UserCode/:ElType/:ElCode/:UserElCode/:Description',
        element: <OtherDynamicDetaillView />
      },
      {
        path: 'CelebrationManagement',
        element: <CelebrationManagement />
      },
      {
        path: 'ReceiptQuery',
        element: <ReceiptQuery />
      },
      {
        path: 'FileManagement',
        element: <FileManagementView />
      },
      {
        path: 'LocationManagement',
        element: <LocationManagement />
      },
      {
        path: 'SearchWorkOrder',
        element: <SearchWorkOrderView />
      },
      {
        path: 'TeknisyenKocuSohbet',
        element: <TeknisyenKocuChatView />
      },
      {
        path: 'LogisticsTracking/PanelRepairDeliveries',
        element: <PanelRepairDeliveriesView />
      },
      {
        path: 'LogisticsTracking/PanelServicePickups',
        element: <PanelServicePickupsView />
      },
      {
        path: 'LaborForm',
        element: <LaborFormView />
      },
      {
        path: 'CreateBulletin',
        element: <CreateBulletin />
      },
      {
        path: 'BulletinList',
        element: <BulletinList />
      },
      {
        path: 'DraftList',
        element: <DraftList />
      },
      {
        path: 'TseHybSurecleri',
        element: <TseHybSurecleriView />
      },
      {
        path: 'AronRotam',
        element: <AronRotamView />
      },
      {
        path: 'BpoMutabakat',
        element: <BpoMutabakatView />
      },
      {
        path: '*',
        element: <Navigate to="/errors/error-404" replace />
      }
    ]
  }
];
